import React from 'react';
import PropTypes from 'prop-types';
import ConditionalLink from '@plone/volto/components/manage/ConditionalLink/ConditionalLink';
import Component from '@plone/volto/components/theme/Component/Component';
import { flattenToAppURL, isInternalURL } from '@plone/volto/helpers/Url/Url';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowRight } from '@fortawesome/free-solid-svg-icons';

const SummaryTemplate = ({ items, linkTitle, linkHref, isEditMode }) => {
  let link = null;
  let href = linkHref?.[0]?.['@id'] || '';

  if (isInternalURL(href)) {
    link = (
      <ConditionalLink to={flattenToAppURL(href)} condition={!isEditMode}>
        {linkTitle || href}
      </ConditionalLink>
    );
  } else if (href) {
    link = <a href={href}>{linkTitle || href}</a>;
  }

  return (
    <>
      <ul className="items list-unstyled my-0">
        {items.map((item) => (
          <li key={item['@id']} className='mb-4'>
            <article className="listing-item position-relative">

              {(item.image_field || item.image) &&
                <Component componentName="PreviewImage" item={item} alt="" className="listing-item__img" />
              }
              <div className="listing-body">
                <h3 className='listing-item__title'> <ConditionalLink className="listing-item__link stretched-link" item={item} condition={!isEditMode}>{item.title || item.id}</ConditionalLink></h3>
                {item?.description &&
                  <p className='mb-0'>{item.description}</p>
                }
                <span className="item__readMore flex-shrink-0 mt-auto ms-3">
                  <FontAwesomeIcon icon={faArrowRight} />
                </span>
              </div>
            </article>
          </li>
        ))}
      </ul>

      {link && <p className="footer">{link}</p>}
    </>
  );
};

SummaryTemplate.propTypes = {
  items: PropTypes.arrayOf(PropTypes.any).isRequired,
  linkMore: PropTypes.any,
  isEditMode: PropTypes.bool,
};

export default SummaryTemplate;
